import React, { useEffect, useMemo, useState } from 'react';
import classnames from 'classnames';
import { NavMenu, Popover, List, Text, Button, Bubble } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { doLogout } from '@/utils/utils';
import { history, useIntl, useDispatch } from 'umi';
import { ACCESS_LINK, IS_GLOBAL } from '@/pages/home/_config/config';
import { getImg } from '@home/_config/getImgs';
import useTipsView from '@user-center/_hooks/useTipsView';
import { TIPS_VIEW_STATE_KEY_MAP, TIPS_VIEW_STATE_KEYS } from '@user-center/_config/tipsViewState';
import { YEAR_REPORT_NEW_TAG_END_DATE } from '@user-center/_config/yearReport';
import { TIPS_VIEW_MODEL_NAMESPACE } from '@user-center/models/tipsView';
import useUserCenterEvents from '@home/hooks/useUserCenterEvents';

export default function Login(props: any) {
  const intl = useIntl();
  const { userInfo } = props;

  // 退出弹窗下拉
  const [loginVisible, setLoginVisible] = useState(false);

  // 使用 useTipsView Hook 来管理访问状态
  const { tipsViewLoading, isTipsView } = useTipsView(TIPS_VIEW_STATE_KEY_MAP.YEAR_REPORT_PAGE);

  // 判断是否显示新标签
  const yearReportNewVisible = useMemo(() => {
    if (tipsViewLoading || isTipsView || Date.now() >= new Date(YEAR_REPORT_NEW_TAG_END_DATE).getTime()) {
      return false;
    }
    return true;
  }, [tipsViewLoading, isTipsView]);

  // 判断是否登录 登录true 没有登录为false
  const [login, setLogin] = useState(false);

  useEffect(() => {
    if (userInfo?.username) setLogin(true);
    else setLogin(false);
  }, [userInfo]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: `${TIPS_VIEW_MODEL_NAMESPACE}/getTipsViewState`, payload: TIPS_VIEW_STATE_KEYS });
  }, []);

  const auth = useMemo(() => {
    if (!userInfo) return null;
    const tempPermissions = Object.keys(userInfo?.permissions);
    return { permissions: tempPermissions, userName: userInfo?.username };
  }, [userInfo]);

  const accountPermission = useMemo(() => {
    if (!userInfo) return false;
    const permissions = Object.keys(userInfo?.permissions || {}) || [];
    const accountPermission = permissions?.includes('header_account_permission');
    return accountPermission;
  }, [userInfo]);

  // Use event-driven badge logic for User Center entry
  const { hasActiveEvents, activeEvents, firstActiveEvent, triggerEvent } = useUserCenterEvents();

  const isDbuNewFeatures = hasActiveEvents || yearReportNewVisible;

  const handleUserCenterClick = async (e: React.MouseEvent) => {
    e?.stopPropagation();

    if (yearReportNewVisible && !location.pathname.includes('/user-center/year-report')) {
      history.push('/user-center/year-report');
      return;
    }

    const quarterReportEvent = activeEvents.find(event => event.tag === 'user_center_quarter_report');
    const clickEvent = quarterReportEvent || firstActiveEvent;

    if (hasActiveEvents && clickEvent) {
      const targetPath = clickEvent.path;

      try {
        await triggerEvent(activeEvents.map((event) => event.id));
      } catch (error) {
        console.error('Failed to trigger user center event:', error);
      }

      if (targetPath && !location.pathname.includes(targetPath)) {
        history.push(targetPath);
      }
    } else if (!location.pathname.includes('/user-center/')) {
      history.push('/user-center');
    }
  };

  const handlerClickLogout = () => {
    doLogout();
  };

  const handlePermission = () => {
    window.open(ACCESS_LINK);
  };
  // url 路径修正
  const handelClickAdmin = () => {
    // window.open((window.location.href = '/admin'), '_blank');
    const system = window.location.pathname.split('/')[2];
    const opinionGameId =
      system === 'opinion'
        ? window.location.search
          .slice(1)
          .split('&')
          .find((item) => item.includes('gameid='))
          ?.split('=')[1]
        : '';
    const dashboardGameCode = system === 'dashboard' ? window.location.pathname.split('/')[4] : '';
    const systemPath: { [key in typeof system]: string } = {
      dashboard: `/admin/dashboard/game/${dashboardGameCode}`,
      intelligence: '/admin/intelligence',
      opinion: `/admin/opinions/game/${opinionGameId}`,
    };
    window.open(systemPath[system] ? systemPath[system] : '/admin', '_blank');
  };

  return (
    <NavMenu.Item>
      {login ? (
        // 登录样式
        <Popover
          visible={loginVisible}
          onVisibleChange={(visible) => setLoginVisible(visible)}
          placement="bottom-start"
          trigger="hover"
          overlayClassName="dba-nav-menu-overlay"
          overlay={
            <div className="outdown">
              <div className="outdown-title">
                <Text className="outdown-text">Hi&nbsp;,&nbsp;</Text>
                {userInfo?.username}
              </div>
              <List type="option">
                {/* <List.Item className='outdown-flex'>
                  <SvgIcon type='key-m' className='outdown-icon' />
                  <Text className='outdown-item'>Feedback</Text>
                </List.Item> */}
                {accountPermission && (
                  <>
                <Bubble placement="left" trigger="hover" dark
                  style={{ maxWidth: 480 }}
                  content={IS_GLOBAL ? <span dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'dbh_search_dashboard_tip_global' }) }} /> : null}
                >
                  <List.Item className={`${IS_GLOBAL ? 'outdown-global' : ''} outdown-flex`} onClick={handlePermission} disabled={IS_GLOBAL}>
                    <SvgIcon type="key-m" className="outdown-icon" />
                    <Text className="outdown-item">
                      {intl.formatMessage({ id: 'permission_application' })}
                    </Text>
                  </List.Item>
                </Bubble>
                  </>
                )}

                <List.Item className="outdown-flex" onClick={handleUserCenterClick}>
                  <SvgIcon className="outdown-icon" type="user" />
                  <Text className="outdown-item">
                    {intl.formatMessage({ id: 'dbh_user_center' })}
                    {isDbuNewFeatures && (
                      <span className="outdown-item-new">{intl.formatMessage({ id: 'dbh_new' })}</span>
                    )}
                  </Text>
                </List.Item>

                {accountPermission && (
                  <>
                {/* <List.Item className='outdown-flex'>
                  <SvgIcon type='pencil-m' className='outdown-icon' />
                  <Text className='outdown-item'>Customize Homepage</Text>
                </List.Item> */}
                {auth?.permissions.includes('admin') && (
                  <List.Item
                    className="outdown-flex"
                    onClick={handelClickAdmin}
                  >
                    <SvgIcon type="set-up" className="outdown-icon" />
                    <Text className="outdown-item">
                      {intl.formatMessage({ id: 'common_system_admin' })}
                    </Text>
                  </List.Item>
                )}
                {!IS_GLOBAL && <List.Item
                  className="outdown-flex outdown-disable"
                >
                  <SvgIcon type="menu-mobile" className="outdown-icon" />
                  <Text className="outdown-item">
                    {intl.formatMessage({ id: 'dbh_nav_mobile_title' })}
                  </Text>
                </List.Item>}
                  </>
                )}
              </List>
              {!IS_GLOBAL && accountPermission && <img src={getImg('erweima')} className='mini-programme-img' alt="QR Code" />}
              <Button
                className="ns-btn--border out-btn"
                onClick={handlerClickLogout}
              >
                {intl.formatMessage({ id: 'logout' })}
              </Button>
            </div>
          }
        >
          <div className="lay-nav-right">
            {/* user-icon oser-out */}
            <div className={classnames('oser-out', { 'oser-out--has-dot': isDbuNewFeatures })}>
              {userInfo?.username?.[0]?.toUpperCase()}
            </div>
            {isDbuNewFeatures && <span className="lay-nav-right-new-dot" />}
          </div>
        </Popover>
      ) : (
        <div className="lay-nav-right">
          <SvgIcon className="item-icon" type="user" />
        </div>
      )}
    </NavMenu.Item>
  );
}
